import React, { useState, useEffect, useCallback } from 'react';
import { MenuItem, OutlinedInput, Select } from '@mui/material';
import MLCustomIcon from '../CustomIcon';

import './Dropdown.module.scss';

const MLDropdown = ({
  placeholderText = 'Placeholder',
  options,
  selectedOption,
  defaultSelectedOption = '',
  isMutiSelect = false,
  containsPlaceholder = true,
  isPlaceHolderClass = false,
  disabled = false,
  classList,
  hasError = false,
  errorText = '',
  popoverClass = 'custom-popover',
  dropdownIcon = 'Dropdown-icon',
}) => {
  const [dropdownValue, setDropdownValue] = useState('');

  const handleChange = useCallback(
    (event) => {
      const { value } = event.target;
      const newValue = isMutiSelect
        ? typeof value === 'string'
          ? value.split(',')
          : value
        : value;

      setDropdownValue(newValue);
      selectedOption(newValue);
    },
    [isMutiSelect, selectedOption]
  );

  const DropdownIcon = useCallback(
    (props) => (
      <MLCustomIcon
        className="dropdown-icon"
        iconName={dropdownIcon}
        height="14"
        width="14"
        {...props}
      />
    ),
    []
  );

  useEffect(() => {
    if (
      !containsPlaceholder &&
      dropdownValue === '' &&
      defaultSelectedOption === ''
    ) {
      setDropdownValue(options[0]?.key || '');
    } else if (defaultSelectedOption !== '') {
      setDropdownValue(defaultSelectedOption.toString());
    } else if (defaultSelectedOption === '') {
      setDropdownValue('');
    }
  }, [containsPlaceholder, options, defaultSelectedOption]);

  return (
    <div className="flex flex-col gap-1 flex-1 w-fit dropdown-wrapper">
      <Select
        multiple={isMutiSelect}
        displayEmpty
        value={dropdownValue}
        onChange={handleChange}
        input={<OutlinedInput />}
        IconComponent={DropdownIcon}
        className={`dropdown-wrap ${classList ?? ''} ${
          disabled ? 'disabled' : ''
        }`}
        MenuProps={{
          PaperProps: {
            className: popoverClass,
          },
        }}
        inputProps={{ 'aria-label': 'Without label' }}
        disabled={disabled}
      >
        {containsPlaceholder && (
          <MenuItem
            disabled
            value=""
            className={isPlaceHolderClass ? 'placeholder-option' : ''}
          >
            <em>{placeholderText}</em>
          </MenuItem>
        )}

        {options?.map((option) => (
          <MenuItem key={option.key} value={option.key}>
            {isPlaceHolderClass &&
              dropdownValue.toString() === option.key.toString() && (
                <MLCustomIcon
                  key={`icon-${option.key}`}
                  iconName="Dropdown-selected-icon"
                />
              )}
            {option.value}
          </MenuItem>
        ))}
      </Select>
      {hasError && (
        <span className="text-[var(--Red-100)] text-xs">{errorText}</span>
      )}
    </div>
  );
};

export default MLDropdown;
